import { render, staticRenderFns } from "./ConstructionWasteCalculator.vue?vue&type=template&id=4a2969b1&scoped=true"
import script from "./ConstructionWasteCalculator.vue?vue&type=script&lang=js"
export * from "./ConstructionWasteCalculator.vue?vue&type=script&lang=js"
import style0 from "./ConstructionWasteCalculator.vue?vue&type=style&index=0&id=4a2969b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2969b1",
  null
  
)

export default component.exports